import React, { RefObject } from 'react';
import { MessageProps } from './Message';
import Message from './Message';
import { ProtocolMessage } from '../../../types/protocols';

interface MessagesListProps {
  messages: MessageProps[];
  messagesEndRef: RefObject<HTMLDivElement | null>;
  containerRef?: RefObject<HTMLDivElement | null>;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
  onOpenInstruments?: (
    protocol: ProtocolMessage,
    serverId?: number,
    anchor?: { top: number; left: number }
  ) => void;
  onCopyProtocol?: (protocol: ProtocolMessage) => void;
  isGeneratingProtocol?: boolean;
}

const MessagesList: React.FC<MessagesListProps> = ({ messages, messagesEndRef, containerRef, onScroll, onOpenInstruments, onCopyProtocol, isGeneratingProtocol }) => (
  <div id="messages-list" ref={containerRef as any} onScroll={onScroll}>
    {messages.map((message, index) => (
      <Message
        key={
          message.serverId
            ? `server:${message.serverId}`
            : `local:${message.sender}:${message.time}:${message.type}:${message.title ?? ''}:${message.text ?? ''}:${index}`
        }
        {...message}
        onOpenInstruments={onOpenInstruments}
        onCopyProtocol={onCopyProtocol}
        isGeneratingProtocol={isGeneratingProtocol}
      />
    ))}
    <div ref={messagesEndRef} />
  </div>
);

export default MessagesList; 